<div pias-layout-content>
    <div id="form-navigation-tab-container" class="container-fluid">
        <div id="form-navigation-tab-header" class="d-flex justify-content-between">
            <h5 class="page-header">Applicant Onboarding</h5>
        </div>

        <div>
            <mat-card appearance="raised">
                <mat-card-content>
                    <mat-tab-group #tabGroup [(selectedIndex)]="selectedIndex"
                        (selectedTabChange)="this.__onAgentOnboardingTabChange($event)">
                        <mat-tab label="Application" id="new-repapplication">
                            @if(this.currentUserRole === 'Introducer - Individual'){
                            <app-introducer-form-individual></app-introducer-form-individual>
                            }@else if(this.currentUserRole === 'Introducer - Corporate'){
                            <app-introducer-form-corporate></app-introducer-form-corporate>
                            }@else{
                            <app-new-rep-application></app-new-rep-application>
                            }
                        </mat-tab>
                        @if(this.onboardingComments){
                        <mat-tab label="Review Comments" id="comments">
                            <app-onboarding-comments></app-onboarding-comments>
                        </mat-tab>
                        }
                    </mat-tab-group>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>